import { 
  GET_TIPO_RANGO,
  GET_TIPOS_RANGO,
  GET_TIPOS_RANGO_ALL,
  GET_TIPOS_RANGO_COUNT,
  ADD_TIPO_RANGO,
  DELETE_TIPO_RANGO,
  UPDATE_TIPO_RANGO,
  GET_FILTROS_TIPOS_RANGO } from "../action"

// ** Initial State
const initialState = {
  data: [],
  allData: [],
  selectedProducto: {},
  gruposAtributos: [],
  atributos: [],
  categorias: [],
  familias: [],
  tiposrango: [],
  selectedtiporangoId: 1,
  params: {},
  processing: false,
  filtros: {}
}

const prefix = 'tiposrango'

const tiposrango = (state = initialState, action) => {
  switch (action.type) {
    case `${prefix}/GET_ALL_DATA`:
      return { ...state, allData: action.data }
      case GET_TIPOS_RANGO:
      return {
        ...state,
        data: action.tiposrango,
        total: action.total || 0,
        processing: false
      }
      case GET_TIPOS_RANGO_ALL:
      return {
          ...state,
          tiposrango: action.tiposrango,
          processing: false
      }
     case GET_TIPO_RANGO:
       return { ...state, selectedTiporango: action.selectedTiporango }
    case ADD_TIPO_RANGO:
      return { ...state, data: state.data.concat(action.data) }
    case DELETE_TIPO_RANGO:
      return { ...state, data: [...state.data].filter(tiporango => tiporango.id !== action.data)}
    case GET_TIPOS_RANGO_COUNT:
      return { ...state, total: action.total }
    case UPDATE_TIPO_RANGO:
      return { ...state, data: state.data.map(tiporango => (tiporango.id === action.data.id ? action.data : tiporango)) }
    case GET_FILTROS_TIPOS_RANGO:
      return {
        ...state,
        filtros: action.filtros
      }
    default:
      return { ...state }
  }
}
export default tiposrango
